package com.milta.core.localization

/**
 * MIL-99 — "Adresse de chargement" section of route creation, shared by the mobile
 * `CreateRouteScreen` (Enterprise mode) and the web `WebVerifyAssignRouteScreen`. Cancel/Delete
 * buttons of the delete dialog and the mobile sheet's "Enregistrer" reuse [CommonStrings].
 */
data class LoadingAddressStrings(
    /** Section title (mobile) / card eyebrow (web). */
    val title: String,
    /** Info message shown while no address is selected (empty list or selection deleted). */
    val emptyMessage: String,
    /** Mobile closed select, nothing selected. */
    val selectPlaceholder: String,
    /** Mobile bottom sheet subtitle. */
    val sheetSubtitle: String,
    /** Badge on the selected address. */
    val startPointBadge: String,
    val newAddressAction: String,
    val mobileSearchPlaceholder: String,
    val webSearchPlaceholder: String,
    val deleteDialogTitle: String,
    /** Contains a "%s" placeholder replaced by the address title. */
    val deleteDialogMessage: String,
    /** Web — hint under the disabled submit button. */
    val webSubmitBlockedHint: String,
    /** Backend 400 `loading_address_required`. */
    val errorRequired: String,
)
